import React, { Component } from 'react';

import './RouteInfoList.scss';
import { BundleRoute } from '../../types/bundleTypes';
import RouteInfo from './RouteInfo';

interface Props {
  routes: BundleRoute[];
  selectedRoutes: string[];
  onSelectRoute: (id: string) => void;
  onDeselectRoute: (id: string) => void;
}

interface State {
  expandedRouteIds: string[];
}

export default class RouteInfoList extends Component<Props, State> {
  constructor(props) {
    super(props);

    this.state = {
      expandedRouteIds: [],
    };
  }

  onExpandRoute = (route: BundleRoute, expanded: boolean) => {
    if (expanded) {
      this.setState({
        expandedRouteIds: [...this.state.expandedRouteIds, route.id],
      });
    } else {
      this.setState({
        expandedRouteIds: this.state.expandedRouteIds.filter(
          id => id !== route.id
        ),
      });
    }
  };

  render() {
    const { routes, selectedRoutes } = this.props;

    return (
      <div>
        {routes.length === 0 && (
          <div
            style={{
              display: 'flex',
              justifyContent: 'space-between',
              paddingBottom: 2,
              backgroundColor: '#f0f0f0',
            }}
          >
            No routes to show
          </div>
        )}
        {routes.map(route => (
          <div key={route.id} className="route-info-list">
            <RouteInfo
              route={route}
              selected={selectedRoutes.includes(route.id)}
              onSelectRoute={this.props.onSelectRoute}
              onDeselectRoute={this.props.onDeselectRoute}
              expanded={this.state.expandedRouteIds.includes(route.id)}
              onExpand={this.onExpandRoute}
            />
          </div>
        ))}
      </div>
    );
  }
}
